import { customSanitize } from "../../../utils/customSanitize";
import styles from "./Contact.module.scss";

interface ContactProps {
  contact: {
    title: string;
    content: string;
  };
}

export const Contact = ({ contact }: ContactProps) => {
  if (!contact) return <></>;

  const { title, content } = contact;

  return (
    <div className={styles.contact}>
      <div className={``}>
        <span className="footer-headline h3 is-block">{title}</span>
      </div>
      <div
        className="footer-text"
        dangerouslySetInnerHTML={{ __html: customSanitize(content) }}
      />
    </div>
  );
};
